import Image from "next/image";
import { EJHEALTH_COLORS, EJHEALTH_TYPE } from "@/lib/theme/ej-health";
import type { Author } from "@/fixtures/ej-health/fixtures";

interface Props {
  author: Author;
  size?: number;
  variant?: "default" | "onDark" | "elevated";
}

export function AuthorChip({ author, size = 28, variant = "default" }: Props) {
  const onDark = variant === "onDark";
  const elevated = variant === "elevated";
  const nameColor = onDark ? EJHEALTH_COLORS.textOnDark : EJHEALTH_COLORS.dark;

  if (elevated) {
    return (
      <div className="flex items-center gap-3">
        <span
          className="relative inline-block overflow-hidden rounded-full"
          style={{ width: 56, height: 56, backgroundColor: EJHEALTH_COLORS.surfaceAlt }}
        >
          <Image src={author.avatar} alt={author.name} fill className="object-cover" unoptimized />
        </span>
        <span className="flex flex-col gap-0.5">
          <span style={{ ...EJHEALTH_TYPE.cardTitleSm, color: EJHEALTH_COLORS.dark }}>
            {author.name}
          </span>
          <span style={{ ...EJHEALTH_TYPE.meta, color: EJHEALTH_COLORS.textMuted }}>
            專欄作者
          </span>
        </span>
      </div>
    );
  }

  return (
    <span className="inline-flex items-center gap-2">
      <span
        className="relative inline-block overflow-hidden rounded-full"
        style={{ width: size, height: size, backgroundColor: EJHEALTH_COLORS.surfaceAlt }}
      >
        <Image src={author.avatar} alt={author.name} fill className="object-cover" unoptimized />
      </span>
      <span style={{ ...EJHEALTH_TYPE.meta, color: nameColor, letterSpacing: "0.04em" }}>
        {author.name}
      </span>
    </span>
  );
}
